// extracted by mini-css-extract-plugin
export var centerText = "_60-8";
export var container = "_60-0";
export var doughnutContainer = "_60-7";
export var legend = "_60-a";
export var legendItemColorDisplay = "_60-b";
export var legendItemLabel = "_60-d";
export var legendItemValue = "_60-c";
export var lg = "_60-5";
export var maxWidth = "_60-9";
export var md = "_60-4";
export var responsive = "_60-6";
export var sm = "_60-3";
export var xs = "_60-2";
export var xxs = "_60-1";